<app-dialog
  #dialog
  [key]="dialogKey"
  [action]="dialogKey"
  [headerTheme]="'simple'"
  [title]="'Editar e aplicar proposta'"
  [appendTo]="'body'"
  [maxWidth]="'640px'"
  (onClose)="onDialogClosed()">
  @if (proposal(); as current) {
    <div class="apply" data-testid="dictionary-proposal-apply-dialog">
      <p class="apply__context">
        <strong>{{ current.standardAccountLabel ?? 'Conta padrão' }}</strong>
        <span>{{ statementLabel() }} · {{ kindLabel() }}</span>
      </p>
      <p class="apply__hint">
        Aplicar cria uma versão nova do dicionário. O agente de De/Para passa a usar o texto na
        próxima execução, e a versão anterior continua no histórico.
      </p>

      <app-input
        [type]="'textarea'"
        [label]="textLabel()"
        [placeholder]="'Texto genérico, sem nome de empresa, pessoa ou banco'"
        [required]="true"
        [textCenter]="false"
        [maxLength]="textMaxLength"
        [ngModel]="text()"
        (ngModelChange)="text.set($event ?? '')"
        data-testid="dictionary-proposal-apply-text" />

      @if (isExclude()) {
        <app-select
          [label]="'Para onde vai (conta padrão de destino)'"
          [placeholder]="'Escolha a conta de destino'"
          [options]="destinationOptions()"
          [appendTo]="'body'"
          [ngModel]="destinationId()"
          (ngModelChange)="destinationId.set($event ?? null)"
          data-testid="dictionary-proposal-apply-destination" />
      }

      <app-input
        [type]="'textarea'"
        [label]="'Nota (opcional)'"
        [placeholder]="'Por que ajustou o texto do revisor'"
        [textCenter]="false"
        [maxLength]="noteMaxLength"
        [ngModel]="note()"
        (ngModelChange)="note.set($event ?? '')"
        data-testid="dictionary-proposal-apply-note" />
    </div>
  }

  <ng-template #footer>
    <div class="apply__footer">
      <app-button
        [label]="'Cancelar'"
        [theme]="'white'"
        [type]="'button'"
        (sendButtonClick)="close()" />
      <app-button
        [label]="'Aplicar'"
        [theme]="'default'"
        [type]="'button'"
        [disabled]="!isFormValid()"
        data-testid="dictionary-proposal-apply-confirm"
        (sendButtonClick)="submitAction()" />
    </div>
  </ng-template>
</app-dialog>
